import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbFormFieldModule,
  NbInputModule,
  NbToastrService,
} from '@nebular/theme';
import { finalize } from 'rxjs/operators';
import { NgxMaskDirective } from 'ngx-mask';
import { PessoaDto } from '../../core/api/pessoaDto';
import { Pessoa } from '../../core/api/pessoa';
import { PessoaService } from '../../core/api/pessoa.service';

import { mensagemDeErro } from '../../utils/mensagem-erro';
import { MASCARAS } from '../../utils/mascaras';
@Component({
  selector: 'app-pessoa-telefone-edit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NbButtonModule,
    NbInputModule,
    NbFormFieldModule,
    NgxMaskDirective,
  ],
  templateUrl: './pessoa-telefone-edit-dialog.component.html',
  styleUrls: ['./pessoa-telefone-edit-dialog.component.scss'],
})
export class PessoaTelefoneEditDialogComponent implements OnInit {
  /** `FRM-10` — máscara vem de um lugar só. */
  protected readonly mascaras = MASCARAS;

  @Input({ required: true }) pessoaId!: string;
  @Input() pessoaNome = '';
  @Input() telefoneInicial = '';

  telefone = '';
  salvando = false;

  constructor(
    private pessoaService: PessoaService,
    private toastr: NbToastrService,
    protected ref: NbDialogRef<PessoaTelefoneEditDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.telefone = this.telefoneInicial ?? '';
  }

  private pessoaParaDto(p: Pessoa): PessoaDto {
    return {
      nome: p.nome ?? '',
      cpf: p.cpf ?? '',
      // CTR-06/TAB-14: data pura atravessa como veio. `new Date('1990-05-10')` interpreta
      // como meia-noite UTC e, em fuso negativo, reenviava a data recuada em um dia — ao
      // salvar um telefone.
      dataNascimento: p.dataNascimento ?? undefined,
      sexo: p.sexo ?? '',
      email: p.email ?? '',
      telefone: p.telefone ?? '',
      batizado: p.batizado ?? false,
      primeiraComunhao: p.primeiraComunhao ?? false,
      necessidadeEspecial: p.necessidadeEspecial ?? '',
      endereco: p.endereco ?? '',
    };
  }

  cancelar(): void {
    this.ref.close(false);
  }

  salvar(): void {
    const id = this.pessoaId?.trim();
    if (!id) {
      this.toastr.warning('Pessoa sem identificador.', 'Telefone');
      return;
    }
    this.salvando = true;
    this.pessoaService.buscarPorId(id).subscribe({
      next: (p) => {
        const dto = this.pessoaParaDto(p);
        dto.telefone = this.telefone.trim();
        this.pessoaService
          .atualizar(id, dto)
          .pipe(finalize(() => (this.salvando = false)))
          .subscribe({
            next: () => {
              this.toastr.success(`Telefone de ${this.pessoaNome} atualizado.`, 'Telefone');
              this.ref.close(dto.telefone ?? '');
            },
            error: (err) => {
              const msg =
                mensagemDeErro(err, 'Não foi possível salvar o telefone.');
              this.toastr.danger(msg, 'Erro');
            },
          });
      },
      error: (err) => {
        this.salvando = false;
        this.toastr.danger(mensagemDeErro(err, 'Não foi possível carregar os dados da pessoa.'), 'Erro');
      },
    });
  }
}
